module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-br":{"hide_ads":"Esconder Anúncios","yuca":"Anúncios patrocinados por <b>Yuca</b>"},"en":{"hide_ads":"Hide Listings","yuca":"Ads sponsored by <b>Yuca</b>"}}')
  delete Component.options._Ctor
}
